module.exports = __webpack_public_path__ + "img/inst-modal-16.bf462ff7.png";